import ReactDOM from 'react-dom/client';
import {isDev} from 'utils/constants';
import {isMailClient, isOKClient, isSdkClient} from 'utils/utils';
import {App} from './core/App';
import {bridge} from 'utils/bridge';

const container = document.getElementById('root');

if (!container) {
    throw new Error('Failed to find the root element');
}

const root = ReactDOM.createRoot(container);

if (bridge && !isDev) {
    // для прод сборки
    if (!isOKClient() && !isMailClient() && !isSdkClient()) {
        // в ОК и почте метод VKWebAppGetConfig недоступен
        bridge
            .sendWithCatch('VKWebAppGetConfig')
            .then(({appearance}) => root.render(<App initialTheme={appearance} />))
            .then(() => bridge && bridge.sendWithCatch('VKWebAppInit'))
            .catch(() => {});
    } else {
        root.render(<App />);
        bridge.sendWithCatch('VKWebAppInit').catch(() => {});
    }
} else {
    // для локальной разработки
    root.render(<App />);
    bridge && bridge.sendWithCatch('VKWebAppInit').catch(() => {});
}
